import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';
import pressMenuHide from '../lib/press-menu-hide';
import SpecialistsPage from '../components/press-page/specialists-page';
import { bootstrapApp } from '../lib/actions';

class SpecialistsRoute extends Component {
  componentDidMount() {
    pressMenuHide();
  }

  render() {
    return (
      <div>
        <DocumentTitle title="Specialists | NerdWallet" />
        <SpecialistsPage specialistsData={this.props.specialistsData} />
      </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
SpecialistsRoute.displayName = 'SpecialistsRoute';
SpecialistsRoute.analyticsName = 'specialists_page';

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
SpecialistsRoute.propTypes = {
  specialistsData: PropTypes.object.isRequired,
};

SpecialistsRoute.bootstrap = function bootstrap(store, req, res, callback) {
  store.dispatch(
    bootstrapApp({
      name: 'specialists-page',
      callback,
      query: req.query,
    })
  );
};

export default connect(({ specialistsData }) => ({ specialistsData }))(
  SpecialistsRoute
);
